import {createContext, useContext} from 'react'

import {noop} from '@sdox/utils'

import {PageContext} from '../../context/PageContext'

import type {ReactNode} from 'react'

interface EditableState {
  isEditable: boolean
  setIsEditable: (isEditable: boolean) => void
}

// don't export context, so it can only be accessed with the 'useIsEditableContext' hook.
const EditableContext = createContext<EditableState>({isEditable: false, setIsEditable: noop})

interface EditableProviderProps {
  value: EditableState
  children?: ReactNode
}

export const EditableContextProvider = (props: EditableProviderProps) => {
  return <EditableContext.Provider {...props} />
}

export const useIsEditable = () => {
  const editableContext = useContext(EditableContext)
  const pageContext = useContext(PageContext)

  if (editableContext === undefined) {
    return false
  }

  // is inside page but page is not editable
  if (pageContext !== undefined && !pageContext.page.isEditable) {
    return false
  }

  return editableContext.isEditable
}
